import { defineStore } from 'pinia';
import _ from 'lodash';

import { type Organization } from '../models';
import { useAuthorizationStore } from './authorizationStore';

export const useOrganizationStore = defineStore('organization', {
    state: () => ({
        currentOrganizationPath: null as Organization[] | null
    }),
    actions: {
        setCurrentOrganizationPath(path: Organization[]): void {
            const authorizationStore = useAuthorizationStore();

            this.currentOrganizationPath = _.cloneDeep(path);
            if (this.currentOrganization) {
                authorizationStore.setOrganizationFlags(
                    this.currentOrganization.clientAdmin,
                    this.currentOrganization.topLevel,
                    this.currentOrganization.publisher,
                    !!this.currentOrganization.childrenCount
                );
            }
        },
        cleanCurrentOrganizationPath(): void {
            const authorizationStore = useAuthorizationStore();

            this.currentOrganizationPath = null;
            authorizationStore.cleanOrganizationFlags();
        }
    },
    getters: {
        currentOrganization: (state): Organization | undefined => state.currentOrganizationPath?.[state.currentOrganizationPath.length - 1],
        parentsIds: (state): number[] => state.currentOrganizationPath?.slice(0, -1).map(organization => organization.id) ?? []
    }
});